import React, { useEffect } from 'react';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { listCentersAction } from '../../actions/centersActions';
import { listJurisdictionsAction } from '../../actions/proceedingActions';

import Spinner from '../../components/Common/Spinner/Spinner';
import JurisdictionList from '../../components/Jurisdiction/JurisdictionList';

import es from '../../lang/es';
import Layout from '../Layout';

const Main = () => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Triago el store
    const centersLoading = useSelector( state => state.centers.loading );
    const centers = useSelector( state => state.centers.centers );
    const jurisdictionLoader = useSelector( state => state.proceeding.loading );
    const selectedCenter = useSelector( state => state.proceeding.selectedCenter );
    //Init methods
    useEffect(() => {
        loadCenters();
    }, []);
    //Load centers
    const loadCenters = () => {
        //Check if is loaded
        if(!centers){
            //Call dispatch
            dispatch( listCentersAction() );
        }
    }
    //Load jurisdiction data
    const handleJurisdictions = center => {
        //Llamo al dispatch y listo los fueros
        dispatch( listJurisdictionsAction(center) );
    }
    //Render
    return (
        <Spinner active={centersLoading || jurisdictionLoader}>
            <Layout 
                title={es.APP_NAME} 
                subtitle={es.SELECT_CENTER}
                items={[
                    {
                        title: es.HOME
                    }
                ]}
            >
                <Col xs={12}>
                    <Alert variant="info">
                        Bienvenido, seleccione el <strong>Centro Judicial</strong> para comenzar, y se mostrarán los <strong>Fueros</strong> correspondientes al mismo. Una vez seleccionado el fuero podrá realizar la búsqueda requerida.
                    </Alert>
                </Col>
                <Col xs={12}>
                    <Row>
                        {
                            centers ? (
                                centers.map(center => (
                                    <Col md={3} key={`cb${center.id}`} className="mb-2 mb-md-2">
                                        <Button variant="primary" block className="text-center" onClick={() => handleJurisdictions(center)}>
                                            <h4>
                                                { center.description.split(' ')[0]+' '+center.description.split(' ')[1] }
                                                <br/>
                                                <strong>
                                                    { center.description.split(' ')[2].toUpperCase() }
                                                </strong>
                                            </h4>
                                        </Button>
                                    </Col>
                                ))
                            ) : null
                        }
                    </Row>
                </Col>

                {
                    selectedCenter ? (
                        <JurisdictionList />
                    ) : null
                }
            </Layout>
        </Spinner>
    );
};

export default Main;